window.CustomSellingPlan =
  window.CustomSellingPlan ||
  function (formID) {
    /**
     * Update the selling plan state and related UI.
     *
     * @param {HTMLElement} variantSelects - The variant selector container.
     */
    function update(variantSelects) {
      if (!variantSelects) return;

      const form = document.querySelector(`#${formID}`);
      const subscription = document.querySelector(`[data-form-id="${formID}"].subscription-option`);

      if (!form || !subscription) return;

      const subscriptionInput = subscription.querySelector(
        'input[type="radio"][name="selling_plan_id"][value="subscription"], input[name="selling_plan_id"]'
      );

      // Find the currently selected selling plan for the active variant.
      const variantSellingPlan = variantSelects.querySelector(
        "[data-selling-plan-id]:checked"
      );

      /*
       * Create the hidden selling_plan input if it doesn't already exist.
       * This value is submitted with the product form.
       */
      let sellingPlanInput = form.querySelector('[name="selling_plan"]');

      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.value = "";

        form.appendChild(sellingPlanInput);
      }

      /*
       * If there is no subscription input, we only need to update
       * the hidden selling plan value.
       */
      if (!subscriptionInput) {
        sellingPlanInput.value =
          variantSellingPlan?.getAttribute("data-selling-plan-id") || "";

        return;
      }

      const productInfoContainer = subscriptionInput.closest(
        ".product__info-container"
      );

      /*
       * No selling plan is available for the selected variant.
       * Reset the subscription state.
       */
      if (!variantSellingPlan) {
        subscriptionInput.checked = false;
        sellingPlanInput.value = "";

        productInfoContainer?.classList.remove(
          "selected_selling_plan",
          "has_subscription"
        );

        return;
      }

      const sellingPlanId = variantSellingPlan.getAttribute(
        "data-selling-plan-id"
      );

      /*
       * Toggle whether the current variant supports subscriptions.
       */
      if (sellingPlanId) {
        productInfoContainer?.classList.add("has_subscription");
      } else {
        subscriptionInput.checked = false;
        sellingPlanInput.value = "";

        productInfoContainer?.classList.remove(
          "selected_selling_plan",
          "has_subscription"
        );

        return;
      }

      /*
       * Update the hidden form value based on whether
       * the subscription option is selected.
       */
      if (subscriptionInput.checked) {
        sellingPlanInput.value = sellingPlanId;
        productInfoContainer?.classList.add("selected_selling_plan");
      } else {
        sellingPlanInput.value = "";
        productInfoContainer?.classList.remove("selected_selling_plan");
      }

      /*
       * Update selling plan price information throughout the page.
       */
      const sellingPlanAttributes = {
        price_formated: "data-selling-plan-price_formated",
        price_saving: "data-selling-plan-price_saving",
        price_discount: "data-selling-plan-price_discount",
      };

      Object.entries(sellingPlanAttributes).forEach(
        ([target, attribute]) => {
          const value = variantSellingPlan.getAttribute(attribute) || "";

          document
            .querySelectorAll(`[data-selling-plan="${target}"]`)
            .forEach((element) => {
              element.textContent = value;
            });
        }
      );

      /*
       * Replace selling plan placeholders inside custom text.
       *
       * Supported placeholders:
       * {selling_plan_name}
       * {selling_plan_price}
       * {selling_plan_price_saving}
       * {selling_plan_price_discount}
       */
      document.querySelectorAll("[data-selling_plan_text]").forEach((element) => {
        let text = element.getAttribute("data-selling_plan_text") || "";

        const replacements = {
          "{selling_plan_name}":
            variantSellingPlan.getAttribute("data-selling-plan-name") || "",

          "{selling_plan_price}":
            variantSellingPlan.getAttribute(
              "data-selling-plan-price_formated"
            ) || "",

          "{selling_plan_price_saving}":
            variantSellingPlan.getAttribute(
              "data-selling-plan-price_saving"
            ) || "",

          "{selling_plan_price_discount}":
            variantSellingPlan.getAttribute(
              "data-selling-plan-price_discount"
            ) || "",
        };

        Object.entries(replacements).forEach(([placeholder, value]) => {
          text = text.replaceAll(placeholder, value);
        });

        element.innerHTML = text;
      });

      /*
       * Replace selling plan inside custom text.
       *
       * Supported placeholders:
       */
      document.querySelectorAll("[data-selling_plan]").forEach((element) => {
        const attributes = element.closest('.variant-container').querySelector('input[data-selling-plan-id]');
        if( ! attributes) return;

        const attribute = element.getAttribute('data-selling_plan');
        if( ! attributes.getAttribute(`data-selling-plan-${attribute}`)) return;
        
        element.innerHTML = attributes.getAttribute(`data-selling-plan-${attribute}`);
      });
    }

    /**
     * Initialize selling plan functionality once the DOM is ready.
     */
    window.addEventListener("DOMContentLoaded", () => {
      const variantSelects = document.querySelector("variant-selects");

      update(variantSelects);

      /*
       * Listen for Shopify variant changes.
       *
       * When the variant changes, Shopify may replace portions
       * of the product form with newly rendered HTML. Keep the
       * corresponding UI elements synchronized.
       */
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const { sectionId, html } = event.data;

        /*
         * Update the main variant selector.
         */
        const variantSelectDestination = document.getElementById(
          `-${sectionId}`
        );

        const variantSelectSource = html.getElementById(`-${sectionId}`);

        if (variantSelectSource && variantSelectDestination) {
          variantSelectDestination.innerHTML =
            variantSelectSource.innerHTML;

          variantSelectDestination.classList.toggle(
            "hidden",
            variantSelectSource.classList.contains("hidden")
          );
        }

        /*
         * Update the sticky product form.
         */
        const productStickyFormDestination = document.getElementById(
          `product-sticky-form-${sectionId}`
        );

        const productStickyFormSource = html.getElementById(
          `product-sticky-form-${sectionId}`
        );

        if (
          productStickyFormSource &&
          productStickyFormDestination
        ) {
          productStickyFormDestination.innerHTML =
            productStickyFormSource.innerHTML;
        }

        /*
         * Update product unit information.
         */
        const productUnitSource = html.querySelector(
          '[data-product="unit"]'
        );

        if (productUnitSource) {
          document
            .querySelectorAll('[data-product="unit"]')
            .forEach((destination) => {
              destination.innerHTML = productUnitSource.innerHTML;
            });
        }

        /*
         * Recalculate the selling plan state after Shopify
         * has updated the variant HTML.
         */
        update(document.querySelector("variant-selects"));
      });

      /*
       * Subscription option change handler.
       */
      const subscription = document.querySelector(`[data-form-id="${formID}"].subscription-option`);

      if (!subscription) return;

      const subscriptionInput = subscription.querySelector(
        'input[type="radio"][name="selling_plan_id"][value="subscription"], input[name="selling_plan_id"]'
      );

      if (!subscriptionInput) return;

      subscriptionInput.addEventListener("change", () => {
        const variantSellingPlan = document.querySelector(
          "[data-selling-plan-id]:checked"
        );

        /*
         * No selling plan is available for the current variant.
         */
        if (!variantSellingPlan) {
          subscriptionInput.checked = false;
          return;
        }

        const variantFormID = variantSellingPlan.getAttribute("form");
        const form = document.querySelector(`#${variantFormID}`);

        if (!form) return;

        const sellingPlanInput = form.querySelector(
          '[name="selling_plan"]'
        );

        if (!sellingPlanInput) return;

        const productInfoContainer = subscriptionInput.closest(
          ".product__info-container"
        );

        /*
         * Apply or remove the selected selling plan.
         */
        if (subscriptionInput.checked) {
          sellingPlanInput.value =
            variantSellingPlan.getAttribute(
              "data-selling-plan-id"
            ) || "";

          productInfoContainer?.classList.add(
            "selected_selling_plan"
          );
        } else {
          sellingPlanInput.value = "";

          productInfoContainer?.classList.remove(
            "selected_selling_plan"
          );
        }
      });

      /*
       * Pre select Subscription Option
       */
      const params = new URLSearchParams(window.location.search);
      if (params.get('subscription-option') === 'true') {
        document.querySelector(`[data-form-id="${formID}"] [for="subscription-option"]`).click();
      }
    });
  };